import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import useSubscriptionPlan from 'src/hooks/useSubscriptionPlan';
import type { RootState } from 'src/redux/store';
import { useSelector } from 'src/redux/store';
import { ACCOUNT_TYPE } from 'src/types/enum';
import { NAVIGATIONS } from 'src/utils/constants';

export interface UseTrialBadge {
  isOwner: boolean;
  expiryLabel: string;
  onUpgradeClick: () => void;
}

export const useTrialBadge = (): UseTrialBadge => {
  const navigate = useNavigate();
  const { subscriptionExpiryOn } = useSubscriptionPlan();
  const accountType = useSelector((s: RootState) => s.auth.user?.accountType);

  const isOwner = accountType === ACCOUNT_TYPE.ORGANIZATION_OWNER;

  const expiryLabel = subscriptionExpiryOn
    ? format(new Date(subscriptionExpiryOn), 'MMM d')
    : '';

  const onUpgradeClick = () => {
    navigate(NAVIGATIONS.SETTINGS_BILLING, {
      state: { showBillingOverview: false }
    });
  };

  return {
    isOwner,
    expiryLabel,
    onUpgradeClick
  };
};
